import { StyleSheet } from 'react-native';
import { tStyles } from '../../typography';
import colors from '../../colors';
export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 56,
    width: '100%'
  },
  textContainer: {
    flex: 1
  },
  leftContainer: {
    paddingRight: 12
  },
  rightContainer: {
    paddingLeft: 8
  },
  title: {
    ...tStyles.body2
  },
  description: {
    ...tStyles.body3,
    color: colors.C_BLACK_60
  },
  errorMessage: {
    ...tStyles.body4,
    color: colors.C_PRIMARY_RED
  }
});